import { Component, OnInit } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/core/services/alert.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { CartModuleConsts } from '../../contants';
import { CartService } from '../../services/cart.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SharedConsts } from 'src/app/shared/constants';
import { select, Store } from '@ngrx/store';
import { SharedState } from 'src/app/shared/store/reducers';
import { getConfig } from 'src/app/shared/store/selectors/shared.selectors';
import { loadCheckoutWebComponents } from '@checkout.com/checkout-web-components'
import { LoaderService } from 'src/app/shared/loader/loader.service';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: false
})
export class PaymentComponent implements OnInit {
// new varible added for new flow
  cardComponent: any;
  checkoutEngine: any;
  isFormValid: boolean = false; 
  isFormRendered = false; 


  flowComponent: any;
  isPaymentLoading = false;
  paymentSessionId:any = null;;
  checkout_env:any ='';
  publicKey='';
  wantsToSaveCard: boolean = false
  status: boolean = false;
  redirectUrl:any;
  public windowUrl: any;
  bsModalRef: BsModalRef;
  bsModalRefForError: BsModalRef;
  selectedItem: any;
  gatewayToken:any;
  firstHit: any = 1;
  show: boolean = false;
  orderDetail: any;
  componentLoaded = false;
  allProductCounts: any;
  promotionMessage = [];
  saveCardValue: any;
  global_data:any = {};
  errorMessage = '';
  configDetails = '';
  cardtypes = {'VI': 'Visa', 'AE':'American Express', 'MC':'Mastercard', 'DI':'Discover', 'DN':'Diners Club',
  'JCB':'JCB'}
  cardImages = {'VI': 'vi.svg', 'AE':'ae.svg', 'MC':'mc.svg', 'DI':'di.svg', 'DN':'dn.svg',
  'JCB':'jcb.svg'}
  url: any;
  constructor(private cartService: CartService, private statePersist: StatePersistService,
    private alertService: AlertService, private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router, private titleService: Title,
    private modalService: BsModalService,
    private loaderService: LoaderService, 
    public sanitizer:DomSanitizer, private store:Store<SharedState>) {this.getConfigFromStore() }

  
  getConfigFromStore(){
    const config_store$ = this.store.pipe(select(getConfig));
    config_store$.subscribe(res=>this.configDetails = res)
    }

items: any;

  ngOnInit(): void {
    this.orderDetail = null;
    this.titleService.setTitle(CartModuleConsts.PAYMENT_PAGE_TITLE);
    this.checkoutDetail()
    this.statePersist.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
    })
    if(Object.keys(this.statePersist.configDetails).length == 0){
      this.statePersist.getConfigStatus.subscribe((response:any)=>{    
        if(response){
          this.setcheckout()
          this.statePersist.isConfigSetoStore.next(false);
          
        }
      })
    }
    else{
      this.setcheckout()
      this.statePersist.isConfigSetoStore.next(false);
    }
      window.scrollTo(0, 0)

  }


  handlePaymentSuccess(paymentResponse: any) {
    console.log('Payment success response received:', paymentResponse);
    const container = document.querySelector('#flow-container');
    
    // Look for the specific element name Checkout.com generates on your screen
    const nativeCheckbox = container?.querySelector('input[name="shouldSaveCardAtMerchant"]') as HTMLInputElement 
                        || container?.querySelector('#shouldSaveCardAtMerchant') as HTMLInputElement;

    // Extract the exact boolean checked choice state (true if checked, false if empty)
    const isSaveCardChecked = nativeCheckbox ? nativeCheckbox.checked : false;

    // Store it inside your class property variable
    this.wantsToSaveCard = isSaveCardChecked;
    const payloadForMagento = {
      paymentMethod: {
        method: "checkout_com_vault",
        additional_data: {
          // Passes the secure reference hash string out of the iframe response
          public_hash: paymentResponse.payment_token || paymentResponse.id,
          
          // Passes your checkbox state value (true or false) straight to your server logs
          save_card: this.wantsToSaveCard 
        }
      }
    };

    console.log('Sending this unified payload configuration to Magento REST API:', JSON.stringify(payloadForMagento));

    this.googleAnalyticsService.eventEmitter(
      SharedConsts.PLACE_ORDER_EVENT,
      SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
      SharedConsts.PLACE_ORDER_EVENT_ACTION,
      SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
      SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
    );
  
    this.router.navigate(['mycart/order-confirmation']);
    this.isPaymentLoading = false;
  }

  flowInstance: any;
//third

async initializeFlow(): Promise<void> {
  try {
    const checkout = await loadCheckoutWebComponents({
      publicKey: this.publicKey,
      environment: this.checkout_env || 'sandbox', 
      paymentSession: this.paymentSessionId,
      locale: 'en-GB',
      risk: { enabled: false }, // Bypasses sandbox tracker 403 errors
      
      onReady: () => {
        this.isFormRendered = true; // Turn button visibility ON
      },
      
      // 💥 THE HOOK: Natively captures Non-3DS Transaction ID and Date variables
      onPaymentCompleted: (_component: any, response: any) => {
        console.log('🚀 [Non-3DS Hook Success] Payload Captured:', response);
        
        const transactionId = response?.id || response?.payment_token;
        const transactionDate = response?.processed_on || response?.created_on || new Date().toISOString();

        // Ensure the localized order details array has been prepared before mapping
        if (!this.orderDetail) {
          this.orderDetail = {};
        }

        // Complete the configuration object tracking array with Non-3DS payload details
        this.orderDetail["transaction_payment_id"] = transactionId;
        this.orderDetail['transaction_date'] = transactionDate;
        // Save tracking arrays and finalize the route sequence path
        this.statePersist.setLocalStorage('order-detail', this.orderDetail);

        console.log('✅ Final Order Details saved for Non-3DS path:', this.orderDetail);
        if (response?.status !== 'redirect' && !response?.redirect_url) {
          this.router.navigate(['mycart/order-confirmation']);
          this.isPaymentLoading = false;
        }

        
        
      },
      onError: (_component: any, error: any) => {
        if (error?.code === 'component_invalid' || error?.message?.includes('invalid')) {
          this.isPaymentLoading = false;
          return; // Ends the block quietly without showing any alert boxes!
        }
        this.isPaymentLoading = false;
        this.alertService.error(error?.message || CartModuleConsts.PAYMENT_DECLINED);
      }
    } as any);

    this.checkoutEngine = checkout;

    // Create 'card' component type and natively hide their built-in button footer
    this.cardComponent = checkout.create('card', {
      showPayButton: false ,
    } as any);
    
    
    const isCardAvailable = await this.cardComponent.isAvailable();
    if (isCardAvailable) {
      this.cardComponent.mount('#flow-container');
      console.log('Checkout.com secure card inputs successfully mounted.');
      
    } else {
      this.alertService.error(CartModuleConsts.CHECKOUT_NOT_AVAILABLE);
    }

    // CRITICAL: Turn loading state OFF so your custom yellow button shows on screen!
    this.isPaymentLoading = false; 

  } catch (error) {
    this.isPaymentLoading = false;
    this.alertService.error(CartModuleConsts.FAILED_PAYMENT_INTERFACE);
  }
}

// 3️⃣ USER FILL DETAILS AND CLICKS YOUR YELLOW BUTTON -> PLACE ORDER -> SUBMIT CARD
submitPayment(errorTemplate) {
  if (!this.cardComponent) {
    this.alertService.error(CartModuleConsts.FORM_NOT_READY);
    return;
  }
 
  if (!this.cardComponent.isValid()) {
    this.cardComponent.submit().catch(() => {}); 
    
    return; // 🔒 HALTS EXECUTION IMMEDIATELY: Magento createOrder() will never be called!
  }

  // Turn loading animation state ON while processing backend data routing loops
  this.loaderService.isLoading.next(true);
  this.isPaymentLoading = true; 
  console.log('Step 1: Custom yellow button clicked. Placing order in Magento backend first...');

  // Extract auto-rendered checkbox choice state dynamically from DOM
  const container = document.querySelector('#flow-container');
  const nativeCheckbox = container?.querySelector('input[name="shouldSaveCardAtMerchant"]') as HTMLInputElement;
  this.wantsToSaveCard = nativeCheckbox ? nativeCheckbox.checked : false;
  var payload = {'save_card':this.wantsToSaveCard, 'website':1, 'paymentSessionid': this.paymentSessionId['id']}
  var errorTemplate = errorTemplate

  // CALL MAGENTO TO CREATE ORDER FIRST WHEN CLICKED
  this.cartService.createOrder(payload).subscribe({
    next: async (response: any) => {
      console.log('Step 2: Magento Order created successfully! Order ID Reference:', response);
      
      // Map Magento backend response tokens right away into local memory 
      if(response.status == 200)
      {
      this.orderDetail['order_id'] = response.response.order_id;
      this.orderDetail['order_date'] = response.response.order_date;
      this.orderDetail['grand_total'] = response.response.grand_total;
      this.orderDetail['price_visibility'] = this.global_data['price_visibility'];
      this.orderDetail['card_payment'] = 1;
      this.statePersist.setLocalStorage('order-detail', this.orderDetail);

      console.log('Step 3: Triggering Checkout.com secure card validation/tokenization event...');
      
      // Order success -> Instantly trigger card submission within the same click thread
      this.cardComponent.submit()
        .then((paymentResponse: any) => {
          console.log('Step 4: Card submission complete. Evaluating potential 3DS redirection pathways...', paymentResponse);
          
          // 🔒 3DS REDIRECT COMPLIANCE HANDSHAKE (Fires ONLY if card is 3DS)
          if (paymentResponse?.status === 'redirect' || paymentResponse?.redirect_url) {
            const secure3DsUrl = paymentResponse.redirect_url || paymentResponse.links?.redirect?.href;
            if (secure3DsUrl) {
              console.log('Card mandates 3DS challenge. Transferring window focus to:', secure3DsUrl);
              
              // Back up the existing Magento details parameters into temporary localStorage 
              // so your 3DS landing handler can retrieve them after returning from the bank
              const transactionId = paymentResponse?.id ;
              const transactionDate = `${new Date().getDate()} ${new Date().toLocaleDateString('en-GB', { month: 'short' })},${new Date().getFullYear()}`;


              // Complete the configuration object tracking array with Non-3DS payload details
              this.orderDetail["transaction_payment_id"] = transactionId;
              this.orderDetail['transaction_date'] = transactionDate;
              this.statePersist.setLocalStorage('order-detail', this.orderDetail);
              
              window.location.href = secure3DsUrl;
              return;
            }
          }
          this.loaderService.isLoading.next(false);
          console.log('Non-3DS card confirmed. Processing handover to onPaymentCompleted interceptor hook...');
        })
        .catch((error: any) => {
          console.error('Checkout.com secure submission failed:', error);
          this.isPaymentLoading = false;
          this.loaderService.isLoading.next(false);
          this.alertService.error(error?.message || CartModuleConsts.TOKENIZATION_FAILED);
        });
      }
      else if(response.status == 2334){
        this.refreshComponent(errorTemplate, response.response)
      }
      else if(response.status == 1152){
        this.alertService.error(response.response)
        this.router.navigate(['mycart'])
      }
      else{
        this.alertService.error(response.response || CartModuleConsts.FAILED_PLACE_ORDER);
        this.isPaymentLoading = false;
        this.loaderService.isLoading.next(false);
      }
    },
    error: (err) => {
      console.error('Magento order placement failed:', err);
      this.alertService.error(err?.message || CartModuleConsts.FAILED_PLACE_ORDER);
      this.isPaymentLoading = false;
      this.loaderService.isLoading.next(false);
    }
  });
}

refreshComponent(errorTemplate, errorMessage) {
  this.errorMessage = errorMessage
  this.bsModalRefForError = this.modalService.show(errorTemplate, { 
    class: 'modal-dialog-centered custom-modal confirm',
    backdrop: 'static',
    keyboard: false
  });
  
  
}


  setcheckout() {

    const amount = Math.round(
      Number(this.orderDetail?.cart_total?.grand_total) * 100
    );
  
    this.cartService.createPaymentSession().subscribe((response: any) => {
      if(response.status == 200){
        this.paymentSessionId = response.response.paymentSession;
        this.publicKey = response.response.publicKey;
        this.checkout_env = response.response.environment;
    
        setTimeout(() => {
          this.initializeFlow();
        }, 200);

      }
      else {
        this.alertService.error(response.response)
        this.router.navigate(['mycart'])
      }
      
  
    });
  
  }


  changeSaveCard(event){
    this.saveCardValue = event.target.checked
  }

  checkoutDetail(){
    this.cartService.checkoutDetail()
    .subscribe(
      response => {
          if (response.status == 2212){
            this.alertService.error(response.response)
          }
          else{
            this.orderDetail = response.response
            this.promotionMessage = this.orderDetail.one_free_withten_msg
            this.show = false;
            if(this.orderDetail.items_count != '0' && this.orderDetail.min_cases == ''){
              this.firstHit = 1
            }
          
          }
          
        },
        error => { }
    )
  }

  

  detectBrowserName() { 
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  closeInfoPopup(){
    this.bsModalRef.hide()
    this.router.navigate(['mycart'])
  }

  closeErrorPopup(){
    this.bsModalRefForError.hide()
    const currentUrl = this.router.url;
    // 1. Navigate to root or a fake route without updating the browser URL bar
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    // 2. Immediately navigate back to the original URL
    this.router.navigate([currentUrl]);
  });
  }

}
